module.exports = __webpack_public_path__ + "static/media/landingTile4.0ea36849.png";